// The editor writes picker commits upper-cased and generated slots lower-cased, and a stored palette
// may hold either -- a duplicate is only visible once both sides read the same way.
export const normalizedColors = colors => (colors || []).map(color => String(color).toUpperCase())

export const normalizedPalette = palette => ({ ...palette, colors: normalizedColors(palette?.colors) })
